import type { ElementType } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { canJoinCampaign } from "@/helpers/utils";
import useIsParticipant from "@/features/auth/hooks/useIsParticipant";
import type { DigitalCampaignCardData } from "./digitalCampaignTypes";

const RouterLink = Link as ElementType;

type DigitalCampaignJoinButtonProps = {
  campaign?: DigitalCampaignCardData;
  participantId?: string | number;
};

const getButtonLabel = ({ is_draft, budget_type }: DigitalCampaignCardData) => {
  if (is_draft) return "Finalize Selections";
  if (budget_type === "Location Specific") return "Join Now";
  return "Customize Now";
};

export default function DigitalCampaignJoinButton({
  campaign,
  participantId,
}: DigitalCampaignJoinButtonProps) {
  const isPreview = !useIsParticipant();
  if (!canJoinCampaign(campaign)) return null;

  const { id } = campaign || {};
  const search = participantId ? `?participantId=${participantId}` : "";

  return (
    <Button
      variant="contained"
      color="primary"
      component={RouterLink}
      to={{
        pathname: `/participant/join-campaign/${id}`,
        search,
        state: { campaignId: id, from: "/dashboard" },
      }}
      disableElevation
      className="fs-11"
      fullWidth
    >
      {isPreview ? "Preview" : getButtonLabel(campaign)}
    </Button>
  );
}
